import { makelaar } from "../data/property";
import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { trackEvent } from "../lib/analytics";

export default function StickyCallBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-call-bar"
      className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-500 lg:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href={`tel:${makelaar.phoneClean}`}
        data-testid="sticky-call-link"
        onClick={() => trackEvent("cta_click", { location: "sticky_bar", action: "call" })}
        className="flex items-center justify-center gap-3 bg-brand-moss px-6 py-4 text-sm font-medium text-white shadow-2xl"
      >
        <Phone size={18} />
        Bel Carole · {makelaar.phone}
      </a>
    </div>
  );
}
